<div class="db-action-progress db-action-progress_state_{{ongoingActivity.status}} db-action-progress_size_{{size}} sl-action-progress {{customClass}}">
  <span class="db-action-progress__pending sl-action-progress-pending"><db-waiting-spinner [size]="spinnerSize"></db-waiting-spinner></span>
  <span class="db-action-progress__active sl-action-progress-active">
    <db-progress-spinner [size]="spinnerSize" [strokeWidth]="2" [progressPercent]="ongoingActivity.progress"></db-progress-spinner>
  </span>
  <span class="db-action-progress__success sl-action-progress-success"><i class="db-icon db-icon-success"></i></span>
  <span class="db-action-progress__fail sl-action-progress-fail"><i class="db-icon db-icon-error"></i></span>
</div>
